export const categoryRedirects = [
  {
    source: 'lighting',
    destination: 'category/lighting',
  },
  {
    source: 'rugs',
    destination: 'category/rugs',
  },
  {
    source: 'pillows-and-throws',
    destination: 'category/art-and-decor/pillows-and-throws',
  },
  {
    source: 'furniture',
    destination: 'category/furniture',
  },
  {
    source: 'seating',
    destination: 'category/furniture/seating',
  },
  {
    source: 'storage',
    destination: 'category/furniture/storage',
  },
  {
    source: 'tables',
    destination: 'category/furniture/tables',
  },
  {
    source: 'art-and-decor',
    destination: 'category/art-and-decor/',
  },
  {
    source: 'mirrors',
    destination: 'category/art-and-decor/mirrors',
  },
  {
    source: 'ceiling-lights',
    destination: 'category/lighting/ceiling-lights',
  },
  {
    source: 'bed-and-bath',
    destination: 'category/bed-and-bath',
  },
  {
    source: 'fabric-and-wallcoverings',
    destination: 'category/fabric-and-wall-coverings',
  },
  {
    source: 'area-rugs',
    destination: 'category/rugs/area-rugs',
  },
  {
    source: 'runners',
    destination: 'category/rugs/runners',
  },
  {
    source: 'wall-lights',
    destination: 'category/lighting/wall-lights',
  },
  {
    source: 'floor-and-table-lamps',
    destination: 'category/lighting/floor-and-table-lamps',
  },
  {
    source: 'decor',
    destination: 'category/art-and-decor/decor',
  },
  {
    source: 'art',
    destination: 'category/art-and-decor/art',
  },
  {
    source: 'beds',
    destination: 'category/furniture/beds',
  },
  {
    source: 'fabrics',
    destination: 'category/fabric-and-wall-coverings/fabric',
  },
  {
    source: 'wallcoverings',
    destination: 'category/fabric-and-wall-coverings/wall-coverings',
  },
  {
    source: 'accent-rugs',
    destination: 'category/rugs/accent-rugs/accent-rugs',
  },
  {
    source: 'bedding-and-linens',
    destination: 'category/bed-and-bath/bedding-and-linens',
  },
  {
    source: 'soft-bath',
    destination: 'category/bed-and-bath/soft-bath',
  },
]
